import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
import './TeamPage.css';

const TeamPage = () => {
  const team = [
    {
      name: 'Abhishek Yadav',
      position: 'Founder & CEO',
      image: '/abhi.png',
      bio: 'Extensive experience in software development and business strategy.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Shivam Yadav',
      position: 'CTO',
      image: '/shivam.png',
      bio: 'Expert in cloud architecture and AI.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Anayatuallah',
      position: 'Manager',
      image: '/anayat.png',
      bio: 'Expert in Managing a Team.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Raju Chauhan',
      position: 'Lead Developer',
      image: '/raju.png',
      bio: 'Full-stack developer passionate about building scalable applications.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Arpit Gupta',
      position: 'Data Analytics',
      image: '/arpit.png',
      bio: ' Data-driven strategist specializing in transforming complex datasets into actionable business insights and predictive models.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Shraddha Sahu',
      position: 'HR Manager',
      image: '/monali.png',
      bio: 'Experienced in human resources, talent acquisition, and employee relations.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Grace Cavalcante',
      position: 'Business Development Executive (Brazil)',
      image: '/grace.png',
      bio: 'Driving business growth and partnerships across the Brazilian market.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Sumit Kumar',
      position: 'Operations Executive',
      image: '/sumit.png',
      bio: 'Experienced in operations management, process optimization, and team coordination.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Chandan Patel',
      position: 'Flutter Developer',
      image: '/chandan.png',
      bio: 'Skilled in building cross-platform mobile applications with Flutter and Dart.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    },
    {
      name: 'Akash Kumar Gupta',
      position: 'Frontend Developer',
      image: '/akash.png',
      bio: 'Experienced in creating responsive and performant web applications.',
      expertise: [],
      social: {
        linkedin: '',
        twitter: '',
        github: ''
      }
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="team-page"
    >
      <Helmet>
        <title>Our Team | Meet the Experts Behind ZustandTech</title>
        <meta
          name="description"
          content="Meet the talented developers, designers, and strategists behind ZustandTech (Zustand Tech Software Private Limited) - the team building web, mobile, AI, and cloud solutions."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.zustandtech.com/team" />

        <meta property="og:title" content="Our Team | ZustandTech" />
        <meta
          property="og:description"
          content="Meet the team behind ZustandTech's web, mobile, AI, and cloud solutions."
        />
        <meta property="og:url" content="https://www.zustandtech.com/team" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* Team Grid */}
      <section className="team-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="page-heading"
          >
            <h1>Our <span className="gradient-text">Team</span></h1>
            <p>Meet the talented people behind ZustandTech</p>
          </motion.div>

          <div className="team-grid-detailed">
            {team.map((member, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="team-member-card"
              >
                <div className="member-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="member-image"
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x400?text=' + member.name.split(' ')[0];
                    }}
                  />
                  <div className="member-social">
                    {member.social.linkedin && (
                      <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-linkedin"></i>
                      </a>
                    )}
                    {member.social.twitter && (
                      <a href={member.social.twitter} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-twitter"></i>
                      </a>
                    )}
                    {member.social.github && (
                      <a href={member.social.github} target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-github"></i>
                      </a>
                    )}
                  </div>
                </div>
                <div className="member-info">
                  <h3>{member.name}</h3>
                  <p className="member-position">{member.position}</p>
                  <p className="member-bio">{member.bio}</p>
                  <div className="member-expertise">
                    {member.expertise.map((skill, i) => (
                      <span key={i} className="expertise-tag">{skill}</span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Team CTA */}
      <section className="team-cta">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="cta-content"
          >
            <h2>Want to join our team?</h2>
            <p>We're always looking for talented individuals to join us</p>
            <Link to="/careers" className="btn btn-primary">
              View Open Positions <FaArrowRight />
            </Link>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default TeamPage;